import { transform } from 'lodash';

export const keysToLowercase = obj =>
  transform(obj, (res, val, key) => {
    return (res[key.toLowerCase()] = val);
  });
